import { Link } from "react-router-dom";

export default function Banner({data}) {
  return (
    <Link to={data?.link ? data?.link : '#'}>
        <img 
          src={`${!data?.url ? '/images.png' : `${process.env.REACT_APP_API_URL}${data?.url}`}`}
          className={'img-fluid'} 
          alt={data?.description && data?.description} />
    </Link>
  )
}
